import SubjectColumn from "./SubjectColumn";

export const columns = [
    {
        label: "Journal",
        field: "journalName",
    },
    {
        label: "ID",
        field: "publisherJournalId",
    },
    {
        label: "Subject(s)",
        field: "subject",
        format: SubjectColumn.format
    },
];
